import { render, staticRenderFns } from "./register_landing.vue?vue&type=template&id=214ea8fd&scoped=true"
import script from "./register_landing.vue?vue&type=script&lang=js"
export * from "./register_landing.vue?vue&type=script&lang=js"
import style0 from "./register_landing.vue?vue&type=style&index=0&id=214ea8fd&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214ea8fd",
  null
  
)

export default component.exports